import { useState } from "react";

const useLoad = () => {
    const [isLoading, setIsLoading] = useState(false);

    const runWithLoader = async (asyncFunction) => {
        try {
            setIsLoading(true);
            await asyncFunction();
        } catch (error) {
            console.error("Error in runWithLoader:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return [isLoading, runWithLoader];
};

export default useLoad;
